let checkboxList = document.querySelectorAll("input[type='checkbox']");
for (let i = 0; i < checkboxList.length; i++) {
    checkboxList[i].addEventListener('keydown',(event) => {
        if (event.key == "Enter") {
            event.target.click();
        }
    });
}